import { render } from "./ausentismo.vue?vue&type=template&id=e60886c4&scoped=true"
import script from "./ausentismo.vue?vue&type=script&lang=js"
export * from "./ausentismo.vue?vue&type=script&lang=js"

import "./ausentismo.vue?vue&type=style&index=0&id=e60886c4&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60886c4"]])

export default __exports__